import { Button } from "@/components/ui/button";
import { X, Maximize, Minimize } from "lucide-react";

interface ChatHeaderProps {
  onClearChat: () => void;
  onToggleFullScreen: () => void;
  isFullScreen: boolean;
}

export const ChatHeader = ({ onClearChat, onToggleFullScreen, isFullScreen }: ChatHeaderProps) => {
  return (
    <div className="p-3 text-white flex justify-between items-center rounded-t-2xl shadow-md" style={{ backgroundColor: 'rgb(37 99 235 / var(--tw-bg-opacity, 1))' }}>
      <div className="flex items-center gap-2 font-medium">
        <img src="/lovable-uploads/1f16b574-2585-4f89-a895-9af7f8c1fa72.png" alt="Digger Logo" className="h-7 w-7 bg-white p-1" />
        <span>AI Assistant</span>
      </div>
      <div className="flex gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearChat}
          className="h-8 w-8 p-0 text-white hover:bg-digger-blue-light"
          title="Clear chat"
        >
          <X className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onToggleFullScreen}
          className="h-8 w-8 p-0 text-white hover:bg-digger-blue-light"
          title={isFullScreen ? "Exit fullscreen" : "Fullscreen"}
        >
          {isFullScreen ? <Minimize className="h-4 w-4" /> : <Maximize className="h-4 w-4" />}
        </Button>
      </div>
    </div>
  );
};
